/* eslint-disable */
import React from "react";
import { TextField, Link } from "@material-ui/core";
import { Container, Row, Col } from "react-bootstrap";
import css from "assets/css/register.css";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { Button, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { auth, googleprovider, db } from "../../Firebase/firebase.js";
import { Alert } from "react-bootstrap";
import moment from "moment";
import apple from "assets/img/apple.png";
import google from "assets/img/google.png";

function CustomerRegistration() {
  const theme = new useTheme();
  const checkRatio = useMediaQuery(theme.breakpoints.down("sm"));
  const Ipadpro = useMediaQuery(theme.breakpoints.between("md", "1300"));
  const Laptop = useMediaQuery(theme.breakpoints.up("lg"));
  const Ipad = useMediaQuery(theme.breakpoints.between("700", "870"));
  var emailref = React.useRef("");
  var passwordref = React.useRef("");
  var usernameref = React.useRef("");
  const [error, setError] = React.useState("");
  const [messagetype, setMessagetype] = React.useState(true);
  const [currentuser, setCurrentuser] = React.useState("");
  const [showpassword, setShowpassword] = React.useState(false);

  const showPassword = (e) => {
    if (e.target.checked === true) {
      setShowpassword(true);
    } else {
      setShowpassword(false);
    }
  };
  const SignUpWithGoogle = () => {
    auth
      .signInWithPopup(googleprovider)
      .then((result) => {
        var credential = result.credential;
        var token = credential.accessToken;
        var user = result.user;
        db.collection("users")
        .where("uid", "==", user.uid)
        .where("type", "==", "customer")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log( doc.id, " => ", doc.data());
          });
          if (querySnapshot.size !== 0) {
            setMessagetype(true);
            setError("The email address is already in use by another account.");
            setTimeout(() => {
              setError("");
            }, 4000);
          }
          else{
            db.collection("users")
            .doc(user.uid)
            .set({
              type: "customer",
              uid: user.uid,
              date: moment(Date.now()).format("YYYY-MM-DD"),
              displayName: user.displayName,
              email: user.email,
            })
            .then((doc) => {})
            .catch((error) => {
              console.error("");
            });
            setMessagetype(false);
        setError("Account Created Successfully");
        setTimeout(() => {
          setError("");
        }, 4000);
          }
        })
        
      })
      .catch((error) => {
        setError("Error occured while creating account!");
      });
  };

  const SignUpwithApple= ()=>{
    auth
      .signInWithPopup(appleprovider)
      .then((result) => {
        var credential = result.credential;
        var user = result.user;
        var accessToken = credential.accessToken;
        var idToken = credential.idToken;
        db.collection("users")
        .where("uid", "==", user.uid)
        .where("type", "==", "customer")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log( doc.id, " => ", doc.data());
          });
          if (querySnapshot.size !== 0) {
            setMessagetype(true);
            setError("The email address is already in use by another account.");
            setTimeout(() => {
              setError("");
            }, 4000);
          }
          else{
            db.collection("users")
            .doc(user.uid)
            .set({
              type: "customer",
              uid: user.uid,
              date: moment(Date.now()).format("YYYY-MM-DD"),
              displayName: user.displayName,
              email: user.email,
            })
            .then((doc) => {})
            .catch((error) => {
              console.error("");
            });
            setMessagetype(false);
        setError("Account Created Successfully");
        setTimeout(() => {
          setError("");
        }, 4000);
          }
        })
        
      })
      .catch((error) => {
        setError("Error occured while creating account!");
      });
  }
  const clickHandler = () => {
    const Username = emailref.current.value;
    const Password = passwordref.current.value;
    const displayname = usernameref.current.value;
    if (Username !== "" && Password !== "" && displayname !== "") {
      if (Password.length > 6) {
       
        auth
          .createUserWithEmailAndPassword(Username, Password)
          .then((data) => {
            data.user.sendEmailVerification()
            data.user
              .updateProfile({
                displayName: displayname,
              })
              .then(() => {
                console.log("");
              })
              .catch((err) => {
                console.log(err);
              });
            db.collection("users")
              .doc(data.user.uid)
              .set({
                type: "customer",
                uid: data.user.uid,
                date: moment(Date.now()).format("YYYY-MM-DD"),
                displayName: displayname,
                email: Username,
              })
              .then((doc) => {
                // db.collection("users").doc(doc.id).set(
                //     {
                //       docId: doc.id,
                //     },
                //     { merge: true }
                //   );
              })
              .catch((error) => {
                console.error("");
              });
            setMessagetype(false);
            setError("Account Created Successfully");
            setTimeout(() => {
              setError("");
              emailref.current.value = "";
              passwordref.current.value = "";
              usernameref.current.value = "";
            }, 4000);
          })
          .catch((error) => {
            setError("" + error);
            setTimeout(() => {
              setError("");
              emailref.current.value = "";
              passwordref.current.value = "";
              usernameref.current.value = "";
            }, 4000);
          });
      } else {
        setError("Password length must be greater than 6");
      }
    } else {
      setError("Text Fields cannot be empty");
    }
  };
  var stylee;
  if (checkRatio) {
    stylee = {
      marginLeft: checkRatio ? 50 : 200,
    };
  }
  if (Ipadpro) {
    stylee = {
      marginLeft: Ipadpro ? -20 : 200,
    };
  }
  if (Laptop) {
    stylee = {
      marginLeft: Ipadpro ? 200 : 200,
    };
  }

  return (
    <>
      <Container fluid>
        <Row noGutters="true">
          <Col>
            <div className="panel2"></div>
            <img
              className="logo"
              src={require("assets/img/derby-logo.png")}
              alt="logo"
            ></img>
          </Col>
          <Col>
            {checkRatio ? <br></br> : null}
            <div className="SignUpform">
              {checkRatio ? <br></br> : null}
              <h1 className="Header">Create an Account</h1>
              {error && (
                <Alert
                  style={{
                    marginLeft: Ipadpro ? -190 : 5,
                    width: checkRatio ? 280 : Ipadpro ? 500 : 600,
                  }}
                  variant={messagetype ? "danger" : "success"}
                >
                  {error}
                </Alert>
              )}
              <div
                className="textfield"
                style={{ marginLeft: Ipadpro ? -190 : 5 }}
              >
                <TextField
                  required
                  label="Username"
                  type="username"
                  inputRef={usernameref}
                  variant="outlined"
                  style={{ width: checkRatio ? 280 : Ipadpro ? 500 : 600 }}
                />
              </div>
              <div
                className="textfield"
                style={{ marginLeft: Ipadpro ? -190 : 5 }}
              >
                <TextField
                  inputRef={emailref}
                  required
                  label="Email"
                  type="email"
                  variant="outlined"
                  style={{ width: checkRatio ? 280 : Ipadpro ? 500 : 600 }}
                />
              </div>
              <div
                className="passwordtextfield"
                style={{ marginLeft: Ipadpro ? -190 : 5 }}
              >
                <TextField
                  inputRef={passwordref}
                  required
                  label="Password"
                  type={showpassword ? "text" : "password"}
                  variant="outlined"
                  style={{ width: checkRatio ? 280 : Ipadpro ? 500 : 600 }}
                />
              </div>

              <FormControlLabel
                control={
                  <Checkbox
                    onClick={showPassword}
                    name="checkedB"
                    color="primary"
                    style={{ color: "#171942", marginLeft: Ipadpro ? -190 : 8 }}
                  />
                }
                label="Show Password"
              />
              <br></br>
              <Button
                variant="contained"
                onClick={clickHandler}
                style={{
                  backgroundColor: "#171942",
                  width: 180,
                  height: 49,
                  borderRadius: 49,
                  border: null,
                  outline: null,
                  color: "white",
                  marginLeft: checkRatio ? 50 : Ipadpro ? -20 : 200,
                  marginTop: checkRatio ? 30 : 20,
                }}
              >
                Sign Up
              </Button>
              <br></br>
              <br></br>
              <h4
                className="signinwith"
                style={{ marginLeft: checkRatio ? 60 : Ipadpro ? -10 : 210 }}
              >
                Or Sign Up with{" "}
              </h4>
              <img
              onClick={SignUpwithApple}
                style={{
                  marginLeft: checkRatio ? 60 : Ipadpro ? -10 : 210,
                  height: 60,
                }}
                src={apple}
              ></img>
              <img
                onClick={SignUpWithGoogle}
                style={{ marginLeft: checkRatio ? 30 : 30, height: 60 }}
                src={google}
              ></img>

              {checkRatio ? <br></br> : null}
              {checkRatio ? <br></br> : null}

              <p
                style={{
                  fontSize: Ipad ? 20 : 12,
                  marginLeft: checkRatio ? 0 : Ipadpro ? -190 : 5,
                }}
              >
                Already have an Account? <Link href="/customerlogin">Sign In</Link>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
export default CustomerRegistration;
